<script setup>
import { DocumentTextIcon } from "@heroicons/vue/24/outline";
import ActionButton from "@js/components/ActionButton.vue";
import DisplayContentAction from "@js/components/actions/DisplayContentAction.vue";
import Title from "@js/components/titles/Title.vue";
import { computed, h } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { row } = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const buttonTitle = computed(() => {
  if (row.original.description && row.original.requirements) {
    return t("button.seeDescriptionAndRequirements");
  }

  if (row.original.description) {
    return t("button.seeDescription");
  }

  if (row.original.requirements) {
    return t("button.seeRequirements");
  }

  return "";
});

const title = computed(() => {
  if (row.original.description && row.original.requirements) {
    return t("title.descriptionAndRequirements");
  }

  if (row.original.description) {
    return t("title.description");
  }

  if (row.original.requirements) {
    return t("title.requirements");
  }

  return "";
});

const content = computed(() => {
  let children = [];

  if (row.original.description) {
    children.push(
      h("div", {}, [
        h(Title, {
          innerText: t("title.description"),
        }),
        h("div", {
          class: "wysiwyg",
          innerHTML: row.original.description,
        }),
      ]),
    );
  }

  if (row.original.requirements) {
    children.push(
      h("div", {}, [
        h(Title, {
          innerText: t("title.requirements"),
        }),
        h("div", {
          class: "wysiwyg",
          innerHTML: row.original.requirements,
        }),
      ]),
    );
  }

  return h("div", { class: "flex flex-col gap-2" }, children);
});
</script>

<template>
  <div class="flex h-full flex-row items-center gap-2 p-4">
    <DisplayContentAction
      v-if="row.original.description || row.original.requirements"
      :title="title"
      :content="content"
    >
      <template #button="{ setIsOpen }">
        <ActionButton
          size="small"
          class="size-8"
          :title="buttonTitle"
          type="primary"
          :callback="() => setIsOpen(true)"
          :icon="DocumentTextIcon"
        />
      </template>
    </DisplayContentAction>
  </div>
</template>
